import { NAVIGATION } from '../../containers/App/constants';
import { stripLocale } from '../../utils/i18nUrls';
import { createStay22Url } from '../../utils/stay22';

/**
 * @description Builds a Stay22 accommodation URL based on the current pathname.
 * @param {string} pathname - The current URL pathname.
 * @returns {string} The generated Stay22 accommodation URL.
 */
export const buildAccommodationUrl = (rawPathname: string) => {
  const pathname = stripLocale(rawPathname);
  const isSearchPage = pathname.startsWith(NAVIGATION.SEARCH);
  const parts = pathname.split('/');
  const destination = isSearchPage && parts.length >= 4 ? parts[3] : undefined;

  return createStay22Url({
    campaign: isSearchPage ? 'navbar_search' : 'navbar',
    address: destination,
  });
};

export const buildVerytrainUrl = (
  placement: 'navbar' | 'menu' | 'search_bar',
) => {
  const url = new URL('https://www.verytrain.com/');

  url.searchParams.set('utm_source', 'tictactrip');
  url.searchParams.set('utm_medium', 'partenaire');
  url.searchParams.set('utm_campaign', `tictactrip_${placement}_train_hotel`);

  return url.toString();
};
